import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'
import {
  type RequestDeleteAccountResponse,
  type RequestDeleteParams,
} from './types'

export async function requestDeleteAccount(
  agent: BskyAgent,
  params: RequestDeleteParams = {},
  options?: {signal?: AbortSignal},
): Promise<RequestDeleteAccountResponse> {
  const accessJwt = agent.session?.accessJwt
  if (!accessJwt) {
    throw new Error('No active session available')
  }
  // Server may wrap the response in an AT Protocol envelope {encoding, body}.
  const raw = await wsocFetch<
    RequestDeleteAccountResponse & {body?: RequestDeleteAccountResponse}
  >(xrpcPath('eu.wsocial.server.requestAccountDelete'), {
    accessJwt,
    ...((params.serviceId || params.sessionId) && {
      body: {
        ...(params.serviceId && {serviceId: params.serviceId}),
        ...(params.sessionId && {sessionId: params.sessionId}),
      },
    }),
    signal: options?.signal,
  })
  return raw.body ?? raw
}
